import { initialPostsState, initialTopicState, TopicState } from 'mk2/apps/forum/containers/Topic/Topic.reducers';
import { AppState } from 'mk2/reducers';

export const getTopicState = (state: AppState, slug: string): TopicState => {
    if (!state.containers.forum.forumTopic[slug]) {
        return initialTopicState;
    }

    return state.containers.forum.forumTopic[slug];
};

export const getTopicPostsState = (state: AppState, slug: string, hashtags: string[]) => {
    const topicState = getTopicState(state, slug);

    const hashtagsKey = hashtags.length ? hashtags.join(',') : '';
    if (!topicState.posts[hashtagsKey]) {
        return initialPostsState;
    }

    return topicState.posts[hashtagsKey];
};
